import { I18n } from 'react-redux-i18n';

export const downloadTranslations = {
  buttonText: 'download.downloadReport',
  downloadTooltipLabel: 'download.downloadTooltipLabel',
};

export const downloadReportAlternativeText = I18n.t('download.downloadReport');
